module.exports = __webpack_public_path__ + "img/统计分析.ac0ef719.png";